import { IconProps } from '@/types/icon';

export function IconeBookmark(props: IconProps) {
  const { size, color, $fillColor, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={$fillColor || 'transparent'}
      width={size}
      height={size}
      {...rest}
    >
      <path
        d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z"
        stroke={$fillColor || color || 'white'}
        fillOpacity={1}
        strokeWidth={2}
      />
    </svg>
  );
}
